export default "__VITE_ASSET__BaeI_tP6__"